import {
  CREATE_OFFER,
  UPDATE_OFFER,
  UNLOAD_OFFER,
  OFFER_FETCHED_SUCCESS,
  RESET_OFFER,
  UPDATE_ACTION_POOL,
  PUSHED_OFFER,
  OFFER_TOGGLE_FAILED,
  OFFER_TOGGLE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  offers: [],
  actionPool: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_OFFER:
    case UPDATE_OFFER:
      return {
        ...state,
        message: action.payload.msg,
      };

    case RESET_OFFER:
      return {
        ...state,
        message: '',
      };

    case OFFER_FETCHED_SUCCESS:
      return {
        ...state,
        offers: action.payload.offers.map((item) => {
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case UPDATE_ACTION_POOL:
      return {
        ...state,
        actionPool: action.payload.data,
      };

    case PUSHED_OFFER:
      return {
        ...state,
        offers: state.offers.map((item) => {
          if (item.id === action.payload.id) {
            const newItem = { ...item };
            newItem.pushed_at = action.payload.date;
            return newItem;
          }
          return item;
        }),
      };

    case UNLOAD_OFFER:
      return initialState;

    case OFFER_TOGGLE_FAILED:
      return state;

    case OFFER_TOGGLE_SUCCESS:
      return {
        ...state,
        offers: state.offers.map((item) => {
          if (item.id !== action.payload.id) return item;
          const newItem = { ...item };
          newItem.is_active = action.payload.active;
          return newItem;
        }),
      };

    default:
      return state;
  }
};
